"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgChevronRightTt(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "8 0 8 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 7h2.909L16 12l-5.091 5H8l5.091-5z" })));
}
exports.default = tombacIcon_1.default('ChevronRightTt')(SvgChevronRightTt);
//# sourceMappingURL=ChevronRightTt.js.map